
/**
 * Copyright (c) Platform Science Inc. All rights reserved.
 */

import { getAccessTokenFromUrl, redirectToLogin } from './components/Authorization/authorizer';
import { getAccessTokenExpiration, localStorageKeys } from './components/Authorization/userSessionDetails';
import './components/common/appLoader.less';
import { isTokenStillValid } from './util/checkExpiration';
import { getItem, removeItem } from './util/localStorage';
import { setupFeatureHubAnonymous } from './featureFlags/featureFlags';
import { featureHubClientManager } from './featureFlags/featureHubClient';

/**
 * Handles user authentication and redirects based on token validity
 */
async function handleAuthentication(): Promise<void> {
  const token = await getAccessTokenFromUrl();
  const tokenExpiration = getAccessTokenExpiration();

  if (token && isTokenStillValid(tokenExpiration)) {
    const prevLocation = getItem(localStorageKeys.previousPageLocalStorageKey) || '/#/';
    
    removeItem(localStorageKeys.previousPageLocalStorageKey);
    removeItem(localStorageKeys.codeVerifierKey);
    
    window.location.assign(prevLocation);
    await import('./AppRoot' /* webpackChunkName: "eldch-components" */);
  } else {
    redirectToLogin();
  }
}

/**
 * Initializes FeatureHub anonymously and starts authentication flow
 */
async function initializeApp(): Promise<void> {
  try {
    const anonymousClient = await setupFeatureHubAnonymous();
    featureHubClientManager.setClient(anonymousClient as any);
  } catch (error) {
    const { mockFhClient } = await import('./featureFlags/featureFlags');
    featureHubClientManager.setClient(mockFhClient);
  }
  
  await handleAuthentication();
}

initializeApp().catch(() => {
  redirectToLogin();
});
